'use strict';

require('./index.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _marketoForm = require('marketo-form');

var _marketoForm2 = _interopRequireDefault(_marketoForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * MarketoForm
 *
 * React component for embedding a Marketo Forms 2.0 form
 *
 * Marketo's API docs: http://developers.marketo.com/documentation/websites/forms-2-0/
 *
 * Normally, you embed a Marketo form like this:
 *
 *     <script src="//app-ab07.marketo.com/js/forms2/js/forms2.min.js"></script>
 *     <form id="mktoForm_1115"></form>
 *     <script>MktoForms2.loadForm("//app-ab07.marketo.com", "925-YQB-645", 1115);</script>
 *
 * This React component wraps that functionality for you. All you need to provide are the arguments to
 *
 *     MktoForms2.loadForm(baseUrl, munchkinId, formId, [onLoad callback])
 *
 * (as seen in the example above) as React props.
 *
 * TODO: Show some visual indication that the form is loading before Marketo injects it?
 * TODO: (That could be accomplished by defining a callback function here, which removes a loading indicator after load)
 * TODO: Show some fallback message when Marketo is blocked or fails to inject the form?
 */
var MarketoForm = _react2['default'].createClass({
    displayName: 'MarketoForm',


    //mixins: [watchAppNotifierMixin],

    propTypes: {
        'baseUrl': _react2['default'].PropTypes.string, // All of our forms use the same base URL so far, so this is optional
        'munchkinId': _react2['default'].PropTypes.string, // All of our forms use the same munchkinId so far, so this is optional
        'formId': _react2['default'].PropTypes.number.isRequired, // Numeric, typically 4-digit form ID
        'className': _react2['default'].PropTypes.string, // Optional class name(s) for the form element
        'onLoad': _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.func]),
        'trackingId': _react2['default'].PropTypes.string //Optional, will be used for sending as tracking action to GA
    },

    getInitialState: function getInitialState() {
        return {};
    },
    getDefaultProps: function getDefaultProps() {
        return {
            'baseUrl': '//app-ab07.marketo.com',
            'munchkinId': '925-YQB-645',
            'onLoad': null,
            'className': '',
            'trackingId': 'marketoform'
        };
    },
    componentDidMount: function componentDidMount() {
        // Then call loadForm on our div
        _marketoForm2['default'].loadForm(this.props.baseUrl, this.props.munchkinId, this.props.formId, this.onLoad);
    },
    shouldComponentUpdate: function shouldComponentUpdate() {
        // We never want to re-render, since that would override the content injected by Marketo's script
        return false;
    },
    onLoad: function onLoad(form) {
        // Add values to hidden form fields
        // TODO: Ask Paul to add a hidden field for this, and supply timePeriod into it
        // Example: form.vals({"userIsAwesome":"true", "enrollDate":"2014-01-01"});

        // TODO: Also set email/name from account profile if logged in

        // Extract UTM tags from cookies
        var utm_cookies = {
            'hf_source': '',
            'hf_campaign': '',
            'hf_medium': '',
            'hf_channel': '',
            'hf_source_lt': '',
            'hf_campaign_lt': '',
            'hf_medium_lt': '',
            'hf_channel_lt': ''
        };
        var pairs = document.cookie.split(';');
        for (var k in pairs) {
            var parts = $.trim(pairs[k]).split('=');
            var name = parts.shift();
            var value = parts.join('=');
            if (name in utm_cookies) {
                utm_cookies[name] = value;
            }
        }

        // Add extracted UTM values to form submission
        form.setValues({
            'UTM_Source__c': utm_cookies['hf_source'],
            'UTM_Campaign__c': utm_cookies['hf_campaign'],
            'UTM_Medium__c': utm_cookies['hf_medium'],
            'UTM_Channel__c': utm_cookies['hf_channel'],
            'LT_UTM_Source__c': utm_cookies['hf_source_lt'],
            'LT_UTM_Campaign__c': utm_cookies['hf_campaign_lt'],
            'LT_UTM_Medium__c': utm_cookies['hf_medium_lt'],
            'LT_UTM_Channel__c': utm_cookies['hf_channel_lt']
        });

        var onLoadFn = this.props.onLoad;
        if (onLoadFn && typeof onLoadFn !== 'function') {
            // onLoadFn refers to a function on window
            onLoadFn = window[this.props.onLoad];
        }
        if (onLoadFn) {
            // Execute onLoad function
            onLoadFn(form);
        }

        form.onSuccess(this.onFormSuccess);
    },
    onFormSuccess: function onFormSuccess(e) {
        hellofaxJS.trackGoogleAnalyticsEvent(this.props.trackingId, 'Form', window.location.pathname + window.location.search);
    },
    render: function render() {
        var formId = 'mktoForm_' + this.props.formId;
        var classNames = 'rx-marketo-form ' + this.props.className;
        return _react2['default'].createElement(
            'div',
            { className: 'm-marketo-form' },
            _react2['default'].createElement('form', { id: formId, className: classNames })
        );
    }
});

module.exports = MarketoForm;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/marketo-form/index.jsx
 ** module id = 1075
 ** module chunks = 0
 **/